import { render, staticRenderFns } from "./CompanyIncorporationEscalations.vue?vue&type=template&id=32df4280&scoped=true&"
import script from "./CompanyIncorporationEscalations.vue?vue&type=script&lang=js&"
export * from "./CompanyIncorporationEscalations.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIncorporationEscalations.vue?vue&type=style&index=0&id=32df4280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32df4280",
  null
  
)

export default component.exports